import { useQuery } from '@tanstack/react-query';
import { cacheAdminApi } from '../api/cacheAdminApi';
import type { CacheListFilter } from '../types/cacheAdmin';

/**
 * GET /api/eraf/cache-admin/caches — 캐시 목록 (CACHE_READ)
 * queryKey: ['cache-admin', 'list', filters]
 */
export function useCacheList(filters: CacheListFilter) {
  return useQuery({
    queryKey: ['cache-admin', 'list', filters],
    queryFn: () =>
      cacheAdminApi.listCaches({
        tier: filters.tier || undefined,
        keyword: filters.keyword || undefined,
      }),
    staleTime: 30_000,
  });
}
